// extracted by mini-css-extract-plugin
module.exports = {"component":"ui-list_component__afqU3","empty":"ui-list_empty__JatRr"};